var map = {
	"./ad_analyst.jpg": "UTks",
	"./ad_director.jpg": "HkBN",
	"./cocos2d-x.jpg": "SWDU",
	"./front_end_develop.jpg": "Hu4a",
	"./game_operator.jpg": "Ae+J",
	"./game_planer.jpg": "rXdb",
	"./game_test.jpg": "eWJw",
	"./graphic_designer.jpg": "C7MR",
	"./home_poster.jpg": "A8Nn",
	"./home_video_poster.jpg": "EwJ9",
	"./market_operation.jpg": "mJCD",
	"./numerical_plan.jpg": "gfFt",
	"./original_engineer.jpg": "QFCu",
	"./server_develop.jpg": "Zt5Z",
	"./special_designer.jpg": "zrsQ",
	"./u3d_develop.jpg": "LBHI",
	"./ui_designer.jpg": "VNjQ",
	"./video_designer.jpg": "7dAg",
	"./zhaopin_header.jpg": "oH8h"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PtS1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23 ^\.\/.*\.jpg$
// module id = PtS1
// module chunks = 1